module.exports = __webpack_public_path__ + "8a4173745b865f7e025b0b2af016eafd.png";